export const paths = {
  dashboard: "/dashboard",
  transaction: {
    list: "/transactions",
    create: "/transactions/create",
    edit: "/transactions/:id/edit",
  },
  order: {
    list: "/orders",
    create: "/orders/create",
    edit: "/orders/:id/edit",
    detail: "/orders/:id",
  },
  master_data: {
    access_admin: {
      list: "/master-data/access-admin",
      create: "/master-data/access-admin/create",
      edit: "/master-data/access-admin/:id/edit",
    },
    facilities: {
      list: "/master-data/facilities",
      create: "/master-data/facilities/create",
      edit: "/master-data/facilities/:id/edit",
    },
    wedding_packages: {
      list: "/master-data/wedding-packages",
      create: "/master-data/wedding-packages/create",
      edit: "/master-data/wedding-packages/:id/edit",
    },
    packages: {
      list: "/master-data/packages",
      create: "/master-data/packages/create",
      edit: "/master-data/packages/:id/edit",
    },
    vendors: {
      list: "/master-data/vendors",
      create: "/master-data/vendors/create",
      edit: "/master-data/vendors/:id/edit",
    },
    contacts: {
      list: "/master-data/contacts",
    },
  },
  content: {
    about_us: "/content/about-us",
    banner: "/content/banner",
    // event: "/content/event",
    // article: "/content/article",
    article: {
      list: "/content/article",
      create: "/content/article/create",
      edit: "/content/article/:id/edit",
    },
    event: {
      list: "/content/event",
      create: "/content/event/create",
      edit: "/content/event/:id/edit",
    },
    gallery: {
      list: "/content/gallery",
      create: "/content/gallery/create",
      edit: "/content/gallery/:id/edit",
    },
    testimonial: {
      list: "/content/testimonial",
      create: "/content/testimonial/create",
      edit: "/content/testimonial/:id/edit",
    },
    virtual_tour: {
      list: "/content/360-virtual-tour",
      create: "/content/360-virtual-tour/create",
      edit: "/content/360-virtual-tour/:id/edit",
    },
  },
  auth: {
    login: "/auth/login",
    register: "/auth/register",
    callback: "/auth/oauth-callback",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
  },
};
